import { z } from 'zod';
const getFilteredMissionsWithShiftsParamsSchema = z.object({
    additionalFilters: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    sortBy: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    isVolunteerView: z.boolean().optional(),
});
const partialGetFilteredMissionsWithShiftsParamsSchema = getFilteredMissionsWithShiftsParamsSchema.omit({
    additionalFilters: true,
    sortBy: true,
});
const getFilteredMissionsWithShiftsResponseSchema = z.object({
    rows: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    total: z.number(),
    shifts: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
});
const partialGetFilteredMissionsWithShiftsResponseSchema = getFilteredMissionsWithShiftsResponseSchema.omit({
    rows: true,
    shifts: true,
});
export const getFilteredMissionsWithShiftsFunctionDef = {
    name: 'getFilteredMissionsWithShifts',
    requestSchema: getFilteredMissionsWithShiftsParamsSchema,
    responseSchema: getFilteredMissionsWithShiftsResponseSchema,
};
